module.exports = __webpack_public_path__ + "e12705ff0e5fd58447cd825c96fe09d4.svg";